import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const fallbackFonts = ['Open Sans', 'arial', 'sans-serif'];
const scandinavian = ['ScandinavianRegular', ...fallbackFonts].join(',');
const scandinavianBlack = ['scandinavianblack', ...fallbackFonts].join(',');
const scandinavianBold = ['scandinavianbold', ...fallbackFonts].join(',');

// SAS theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#000099', // B3
    },
    secondary: {
      main: '#003cf0', // B1
    },
    error: {
      main: '#e81e14',
    },
    background: {
      default: '#fff',
    },
    text: {
      primary: '#3f3d3a', // G5
      secondary: '#68645c', // G4
    },
  },
  typography: {
    fontFamily: scandinavian,
    fontFamilyBold: scandinavianBold,
    button: {
      fontFamily: scandinavianBlack,
      fontSize: '16px',
    },
    h6: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
      fontSize: '24px',
    },
    h4: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h3: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h2: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
    },
    h1: {
      fontFamily: scandinavianBlack,
      textTransform: 'uppercase',
      fontSize: '32px',
    },
    link: {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: '#003cf0',
      WebkitTapHighlightColor: 'transparent',
    },
    p: {
      fontSize: '14px',
    },
  },
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          minWidth: 'unset',
          minHeight: 'unset',
        },
      },
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontSize: '16px',
        padding: '8px 32px',
      },
    },
    MuiTextField: {
      root: {
        borderRadius: '4px',
      },
    },
    MuiFilledInput: {
      root: {
        borderRadius: '4px',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        backgroundColor: '#fff',
      },
      adornedEnd: {
        paddingRight: '20px',
      },
      input: {
        backgroundColor: '#fff',
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: '#ffffff',
        '&::placeholder': {
          color: '#fff',
        },
      },
      input: {
        backgroundColor: '#ffffff',
        border: 'thin solid #3f3d3a',
        borderRadius: '4px',
        transition: 'all .5s',

        '&:hover': {
          transition: 'all .5s',
          background: '#E4E3E3',
        },

        '&:focus': {
          border: '1px solid #000099',
        },
      },
    },
  },
});

export default responsiveFontSizes(theme);
